import * as React from "react";
import { type IconProps, iconProps } from "../util/IconProps";
export function QuestionIcon(props: IconProps): React.JSX.Element {
  const { color, size, ...rest } = iconProps(props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      {...rest}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11.005 6.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM10.8 8.6c.525-.7 1.143-.862 1.692-.798.616.072 1.123.426 1.32.732.204.317.236.635.125.983-.121.38-.43.829-.97 1.268-.667.542-1.17 1.028-1.496 1.544A2.977 2.977 0 0 0 11 14a1 1 0 1 0 2 0c0-.257.04-.411.16-.6.15-.236.445-.557 1.067-1.063.747-.606 1.343-1.359 1.615-2.211a3.09 3.09 0 0 0-.35-2.676c-.554-.86-1.623-1.502-2.77-1.635-1.215-.14-2.547.285-3.522 1.585a1 1 0 1 0 1.6 1.2Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
